import http from "../utils/request";
import type {
  MerchantId,
  MerchantApproval,
  MerchantApplication,
  MerchantApplicationDetail,
  MerchantApplyQuery,
  MerchantWithdrawal,
  MerchantWithdrawQuery,
  ShopPage,
  ShopResponse,
} from "../types/shopMerchant";

const applyPath = "/shop/merchant/apply";
const withdrawPath = "/shop/merchant/withdraw";

export function listMerchantApplications(
  query: MerchantApplyQuery,
  signal?: AbortSignal
): Promise<ShopPage<MerchantApplication>> {
  return http.post<never, ShopPage<MerchantApplication>>(
    `${applyPath}/list`,
    query,
    { signal }
  );
}

export function getMerchantApplication(
  id: MerchantId
): Promise<ShopResponse<MerchantApplicationDetail>> {
  return http.post<never, ShopResponse<MerchantApplicationDetail>>(
    `${applyPath}/detail/${id}`,
    {}
  );
}

export function approveMerchantApplication(
  data: MerchantApproval
): Promise<ShopResponse<null>> {
  return http.post<never, ShopResponse<null>>(`${applyPath}/auditPass`, data);
}

export function rejectMerchantApplication(
  id: MerchantId,
  auditRemark: string
): Promise<ShopResponse<null>> {
  return http.post<never, ShopResponse<null>>(`${applyPath}/auditReject`, {
    id,
    auditRemark,
  });
}

export function disableMerchant(
  merchantId: MerchantId
): Promise<ShopResponse<null>> {
  return http.post<never, ShopResponse<null>>(`${applyPath}/disable`, null, {
    params: { merchantId },
  });
}

export function enableMerchant(
  merchantId: MerchantId
): Promise<ShopResponse<null>> {
  return http.post<never, ShopResponse<null>>(`${applyPath}/enable`, null, {
    params: { merchantId },
  });
}

export function listMerchantWithdrawals(
  query: MerchantWithdrawQuery,
  signal?: AbortSignal
): Promise<ShopPage<MerchantWithdrawal>> {
  return http.post<never, ShopPage<MerchantWithdrawal>>(
    `${withdrawPath}/list`,
    query,
    { signal }
  );
}

export function approveMerchantWithdrawals(
  ids: MerchantId[]
): Promise<ShopResponse<null>> {
  return http.post<never, ShopResponse<null>>(`${withdrawPath}/auditPass`, {
    ids,
  });
}

export function rejectMerchantWithdrawals(
  ids: MerchantId[],
  auditRemark: string
): Promise<ShopResponse<null>> {
  return http.post<never, ShopResponse<null>>(`${withdrawPath}/auditReject`, {
    ids,
    auditRemark,
  });
}

export function exportMerchantWithdrawals(
  query: Omit<MerchantWithdrawQuery, "ypageNum" | "ypageSize">
): Promise<Blob> {
  return http.post<never, Blob>(`${withdrawPath}/export`, query, {
    responseType: "blob",
  });
}
